import React from 'react';
import {Link} from 'react-router';
import {TextArea, Input, DatePicker} from 'components/tt-forms/common';
import {Dialog} from "@blueprintjs/core";
import { GiaiQuyetDonThu } from 'api';
import { Reception } from 'api';
import { checkServerLive, LimitFileSize, LimitFileType } from 'constants/config';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { ShowIf } from 'components/utils';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import fileDownload from 'js-file-download';
import {downloadFile} from 'components/utils';

const loaiTepDinhKem = 'QUYET_DINH';
const buocGiaiQuyet = 'GIA_HAN';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class GiaHanDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,
      isValid: false,
      btnLoading: false,
      dataGiaiQuyetDon: [],
      soQuyetDinhGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanTTXM: '',
      ngayRaQuyetDinhGiaHanTTXM: '',
      lyDoGiaHanTTXM: '',

      soQuyetDinhGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      ngayRaQuyetDinhGiaHanGiaiQuyet: '',

      id: this.props.id,
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      loaiTepDinhKem: loaiTepDinhKem,
      tenFile: '',
      urlFile: '',
      progress: 0,
      duongDan: '',
      idFile: '',
      idFileRemove: ''
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      thongTinGiaiQuyetDonId: nextProps.thongTinGiaiQuyetDonId,
      id: nextProps.id
    })
  }

  closeDialog() {
    this.setState({
      isValid: false,
      btnLoading: false,
      soQuyetDinhGiaHanTTXM: '',
      ngayHetHanSauKhiGiaHanTTXM: '',
      ngayRaQuyetDinhGiaHanTTXM: '',
      lyDoGiaHanTTXM: '',

      soQuyetDinhGiaHanGiaiQuyet: '',
      lyDoGiaHanGiaiQuyet: '',
      ngayHetHanSauKhiGiaHanGiaiQuyet: '',
      ngayRaQuyetDinhGiaHanGiaiQuyet: '',

      tenFile: '',
      urlFile: '',
      progress: 0,
      duongDan: '',

      isOpen: !this.state.isOpen
    });
  }

  openDialog() {
    this.getTaiLieuVanThu();
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof id != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            soQuyetDinhGiaHanTTXM: res.data.soQuyetDinhGiaHanTTXM ? res.data.soQuyetDinhGiaHanTTXM : '',
            lyDoGiaHanTTXM: res.data.lyDoGiaHanTTXM ? res.data.lyDoGiaHanTTXM : '',
            ngayHetHanSauKhiGiaHanTTXM: res.data.ngayHetHanSauKhiGiaHanTTXM ? new Date(res.data.ngayHetHanSauKhiGiaHanTTXM) : '',
            ngayRaQuyetDinhGiaHanTTXM: res.data.ngayRaQuyetDinhGiaHanTTXM ? new Date(res.data.ngayRaQuyetDinhGiaHanTTXM) : '',

            soQuyetDinhGiaHanGiaiQuyet: res.data.soQuyetDinhGiaHanGiaiQuyet ? res.data.soQuyetDinhGiaHanGiaiQuyet : '',
            lyDoGiaHanGiaiQuyet: res.data.lyDoGiaHanGiaiQuyet ? res.data.lyDoGiaHanGiaiQuyet : '',
            ngayHetHanSauKhiGiaHanGiaiQuyet: res.data.ngayHetHanSauKhiGiaHanGiaiQuyet ? new Date(res.data.ngayHetHanSauKhiGiaHanGiaiQuyet) : '',
            ngayRaQuyetDinhGiaHanGiaiQuyet: res.data.ngayRaQuyetDinhGiaHanGiaiQuyet ? new Date(res.data.ngayRaQuyetDinhGiaHanGiaiQuyet) : '',

            isOpen: !this.state.isOpen
          });
        }
      });
    }
  }

  getTaiLieuVanThu() {
    let params = {
      donId: this.state.id,
      loaiQuyTrinh: loaiQuyTrinh,
      buocGiaiQuyet: buocGiaiQuyet
    }
    GiaiQuyetDonThu.actions.getTaiLieuDinhKemDon.request(params).then(res => {
      if (res.data._embedded) {
        this.setState({
          tenFile: res.data._embedded.taiLieuVanThus[0].tenFile,
          duongDan: res.data._embedded.taiLieuVanThus[0].duongDan,
          idFile: res.data._embedded.taiLieuVanThus[0].taiLieuVanThuId
        });
      } else {
        this.setState({
          tenFile: '',
          duongDan: '',
          idFile: ''
        });
      }
    })
  }

  handleGiaHan() {
    if(this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });
      let params = getParams(this.state.dataGiaiQuyetDon, this.state.id);

      if(this.props.loaiDon == 'DON_TO_CAO') {
        params.soQuyetDinhGiaHanGiaiQuyet = this.state.soQuyetDinhGiaHanGiaiQuyet;
        params.lyDoGiaHanGiaiQuyet = this.state.lyDoGiaHanGiaiQuyet;
        params.ngayHetHanSauKhiGiaHanGiaiQuyet = moment(this.state.ngayHetHanSauKhiGiaHanGiaiQuyet).add(7, 'hours').toISOString();
        params.ngayRaQuyetDinhGiaHanGiaiQuyet = moment(this.state.ngayRaQuyetDinhGiaHanGiaiQuyet).add(7, 'hours').toISOString();
        params.giaHanGiaiQuyet = true;
      } else {
        params.soQuyetDinhGiaHanTTXM = this.state.soQuyetDinhGiaHanTTXM;
        params.lyDoGiaHanTTXM = this.state.lyDoGiaHanTTXM;
        params.ngayHetHanSauKhiGiaHanTTXM = moment(this.state.ngayHetHanSauKhiGiaHanTTXM).add(7, 'hours').toISOString();
        params.ngayRaQuyetDinhGiaHanTTXM = moment(this.state.ngayRaQuyetDinhGiaHanTTXM).add(7, 'hours').toISOString();
        params.giaHanTTXM = true;
      }

      params['don'] = {
        id: this.state.id
      }

      if (this.state.idFile == '' && this.state.duongDan != '') {
        let _params = {
          buocGiaiQuyet: buocGiaiQuyet,
          don: {
            id : this.state.id
          },
          duongDan: this.state.duongDan,
          loaiQuyTrinh: loaiQuyTrinh,
          loaiTepDinhKem: loaiTepDinhKem,

          tenFile: this.state.tenFile
        }
        if (this.props.loaiDon == 'DON_KHIEU_NAI') {
          _params.ngayQuyetDinh = moment(this.state.ngayRaQuyetDinhGiaHanTTXM).add(7, 'hours').toISOString();
          _params.soQuyetDinh = this.state.soQuyetDinhGiaHanTTXM;
          _params.ten ='Quyết định về việc gia hạn thời gian xác minh';

        }

        if (this.props.loaiDon == 'DON_TO_CAO') {
          _params.ngayQuyetDinh = moment(this.state.ngayRaQuyetDinhGiaHanGiaiQuyet).add(7, 'hours').toISOString();
          _params.soQuyetDinh = this.state.soQuyetDinhGiaHanGiaiQuyet;

          _params.ten ='Quyết định về việc gia hạn giải quyết tố cáo';

        }
        this.postTaiLieuVanThu(_params);
      }

      if (this.state.idFile != '' && this.state.duongDan != '') {
        let _params = {
          buocGiaiQuyet: buocGiaiQuyet,
          don: {
            id : this.state.id
          },
          duongDan: this.state.duongDan,
          loaiQuyTrinh: loaiQuyTrinh,
          loaiTepDinhKem: loaiTepDinhKem,
          tenFile: this.state.tenFile
        }

        if (this.props.loaiDon == 'DON_KHIEU_NAI') {
          _params.ngayQuyetDinh = moment(this.state.ngayRaQuyetDinhGiaHanTTXM).add(7, 'hours').toISOString();
          _params.soQuyetDinh = this.state.soQuyetDinhGiaHanTTXM;
          _params.ten ='Quyết định về việc gia hạn thời gian xác minh'
        }

        if (this.props.loaiDon == 'DON_TO_CAO') {
          _params.ngayQuyetDinh = moment(this.state.ngayRaQuyetDinhGiaHanGiaiQuyet).add(7, 'hours').toISOString();
          _params.soQuyetDinh = this.state.soQuyetDinhGiaHanGiaiQuyet
          _params.ten ='Quyết định về việc gia hạn giải quyết tố cáo'
        }
        this.updateTaiLieuVanThu(_params);
      }

      if (this.state.idFile != '' && this.state.duongDan == '') {
        this.deleteTaiLieuVanThu(this.state.idFile);
      }

      this.updateGiaiQuyetDon(params);
    }
  }

  updateGiaiQuyetDon(params) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.thongTinGiaiQuyetDonId},params).then(res => {
      Toastr(msg.giaHanTTXM, 'success');
      this.setState({
        isOpen: !this.state.isOpen,
        btnLoading: false
      });
      this.props.getListData();
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      this.setState({
        btnLoading: false
      });
    });
  }

  onChange(name, e) {
    if (e._d) {
      this.setState({
        [name]: e._d
      })
    } else if (e.target){
      this.setState({
        [name]: e.target.value
      })
    } else {
      this.setState({
        [name]: e
      })
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  uploadFile(e){
    if (e.target.files[0]) {
      let fileName = e.target.files[0].name;
      let ext = fileName.split('.').pop().toLowerCase();
      let fileSize = e.target.files[0].size;
      if (LimitFileType.indexOf(ext) == -1) {
        Toastr(msg.fileTypeErr, 'warning');
      } else if (fileSize > LimitFileSize*1024*1024) {
        Toastr(msg.fileSizeErr, 'warning');
      } else if (fileSize == 0) {
        Toastr(msg.fileSizeNull, 'warning');
      } else {
        let params = {field: 'file', file: e.target.files[0]};

        params.progress = (progress)=>{
          let progressBar = Math.round( (progress.loaded * 100) / progress.total );
          this.setState({progress: progressBar});
        }
        Reception.actions.postFileUpload.request('', params).then(res => {
          let checkURL = '';
          if (res && res.data && !checkServerLive) {
            checkURL = res.data;
          } else if (res && res.data && checkServerLive) {
            checkURL = res.data.id;
          }
          this.setState({
            progress: 0,
            tenFile: fileName,
            duongDan: checkURL
          });
        });

      }
    }
  }

  handleRemove() {
    this.setState({
      duongDan: '',
      tenFile: '',
      progress: 0
    })
  }

  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKemDon.request({id: this.state.idFile}, params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKemDon.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(id) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKemDon.request({id: id}).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  render() {
    return (
      <div className="wrap-link-todo">
        <Link className="itt-clock" onClick={this.openDialog.bind(this)}>Gia hạn</Link>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.closeDialog.bind(this)}
          title="gia hạn giải quyết đơn/vụ việc"
          className="dialog-gh wrap-block">
          <div className="body-dialog-gh">
            <div className="row pl30 pr30 pt20">
              <ShowIf condition={this.props.loaiDon == 'DON_KHIEU_NAI'}>
                <div>
                  <Input className="col-33" label="Số quyết định" placeholder="Nhập số quyết định..." bindValidator={this} channel="formTaoDon" require isValid={this.state.isValid} onChange={this.onChange.bind(this, 'soQuyetDinhGiaHanTTXM')} value={this.state.soQuyetDinhGiaHanTTXM} maxLength={255} />
                  <DatePicker className="col-33" label="Ngày ra quyết định" endDate={new Date()} bindValidator={this} channel="formTaoDon" require isValid={this.state.isValid} onChange={this.onChange.bind(this, 'ngayRaQuyetDinhGiaHanTTXM')} value={this.state.ngayRaQuyetDinhGiaHanTTXM}/>
                  <DatePicker className="col-33" label="Gia hạn đến ngày" startDate={new Date()} bindValidator={this} channel="formTaoDon" require isValid={this.state.isValid} onChange={this.onChange.bind(this, 'ngayHetHanSauKhiGiaHanTTXM')} value={this.state.ngayHetHanSauKhiGiaHanTTXM}/>
                  <TextArea label="Lý do gia hạn" bindValidator={this} channel="formTaoDon" require isValid={this.state.isValid} placeholder="Nhập lý do..." onChange={this.onChange.bind(this, 'lyDoGiaHanTTXM')} value={this.state.lyDoGiaHanTTXM} maxLength={1000}/>
                </div>
              </ShowIf>
              <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO'}>
                <div>
                  <Input className="col-33" label="Số quyết định" placeholder="Nhập số quyết định..." bindValidator={this} channel="formTaoDon" require isValid={this.state.isValid} onChange={this.onChange.bind(this, 'soQuyetDinhGiaHanGiaiQuyet')} value={this.state.soQuyetDinhGiaHanGiaiQuyet} maxLength={255}/>
                  <DatePicker className="col-33" label="Ngày ra quyết định" endDate={new Date()} bindValidator={this} channel="formTaoDon" require isValid={this.state.isValid} onChange={this.onChange.bind(this, 'ngayRaQuyetDinhGiaHanGiaiQuyet')} value={this.state.ngayRaQuyetDinhGiaHanGiaiQuyet}/>
                  <DatePicker className="col-33" label="Gia hạn đến ngày" startDate={new Date()} bindValidator={this} channel="formTaoDon" require isValid={this.state.isValid} onChange={this.onChange.bind(this, 'ngayHetHanSauKhiGiaHanGiaiQuyet')} value={this.state.ngayHetHanSauKhiGiaHanGiaiQuyet}/>
                  <TextArea label="Lý do gia hạn" bindValidator={this} channel="formTaoDon" require isValid={this.state.isValid} placeholder="Nhập lý do..." onChange={this.onChange.bind(this, 'lyDoGiaHanGiaiQuyet')} value={this.state.lyDoGiaHanGiaiQuyet} maxLength={1000}/>
                </div>
              </ShowIf>
              <div className="col-100">
                <h3 className="txt-12 txt-bold txt-upper mb10 mt0">Quyết định gia hạn</h3>
                <div className="desc mb10">
                  <p style={{ marginLeft: 0 }}>Định dạng tập tin đính kèm: .doc, .docx, .pdf, .rar, .zip, .jpg, .png. Dung lượng tối đa: 50mb</p>
                </div>
                <div className="result-upload mb20">
                  <div className="items-upload mb10">
                    <ShowIf condition={this.state.progress > 0}>
                      <div className="pt-progress-bar progress-upload pt-intent-primary">
                        <div className="pt-progress-meter"
                          style={{ width: `${this.state.progress}%` }} >
                        </div>
                      </div>
                    </ShowIf>
                    <ShowIf condition={this.state.progress <= 0}>
                      <div className="item-upload">
                        <ShowIf condition={this.state.duongDan !== ''}>
                          <div>
                            <ShowIf condition={!checkServerLive}>
                              <Link onClick={fileDownload.bind(this, this.state.urlFile, this.state.tenFile)} className="txt-blue txt-underline mr20 name-file-upload">{this.state.tenFile}</Link>
                            </ShowIf>
                            <ShowIf condition={checkServerLive}>
                              <Link onClick={() => {downloadFile(this.state.urlFile, this.state.tenFile)}} className="txt-blue txt-underline mr20 name-file-upload">{this.state.tenFile}</Link>
                            </ShowIf>
                            <div className="wrap-upload-item mr15">Tải lại
                              <input type="file" title="" className="btn-reupload" onChange={this.uploadFile.bind(this)} />
                            </div>
                            <Link className="itt-delete" onClick={this.handleRemove.bind(this)}>Xóa</Link>
                          </div>
                        </ShowIf>
                        <ShowIf condition={this.state.duongDan === ''}>
                          <div className="wrap-upload-item mr15">Tải lên
                            <input type="file" title="" className="btn-reupload" onChange={this.uploadFile.bind(this)} />
                          </div>
                        </ShowIf>
                      </div>
                    </ShowIf>
                  </div>
                </div>
              </div>
              <div className="box-bottom col-100">
                <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this)}><span>Không</span></Link>
                <Link className={this.state.btnLoading ? "btn-action btn-save action-todo btn-loading-inline" : "btn-action btn-save action-todo"} onClick={this.handleGiaHan.bind(this)}><span>Đồng ý</span></Link>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

GiaHanDialog.defaultProps = {
  validators: {}
}

export default GiaHanDialog;



// WEBPACK FOOTER //
// ./src/components/modules/dialog/GiaHanDialog.jsx